import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './notesTabs-jss';
import { Grid, Hidden, Tabs, Tab } from '@material-ui/core';
import PapperBlock from '../PapperBlock/PapperBlock';
import SliderTap from '../Sliders/SliderTap';
import SliderEditoriales from '../Sliders/SliderEditoriales';
import SliderCard from '../Sliders/SliderCard';
import classNames from 'classnames';

class NotesTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
  }
  handleTabChange = (event, newValue) => {
    //this.setState({ selectedTab: newValue });
    if (this.props.onTabChange) {
      this.props.onTabChange(event, newValue);
    } else {
      this.setState({ selectedTab: newValue });
    }
  };

  render() {
    // const { classes, tabSections, idMenuSelected, isSearching } = this.props;
    // const { selectedTab } = this.state;

    const { classes, tabSections, idMenuSelected, isSearching, selectedTab: selectedTabProp } = this.props;
    const selectedTab = selectedTabProp !== undefined ? selectedTabProp : this.state.selectedTab;

    return (
       <div id={tabSections[0].sec_name ? tabSections[0].sec_name.toString().trim() : ""} className={classes.bgRelevant}>
            <div className={classes.wrapperRelevant}>
      <Grid container spacing={0}>
        {/* Tabs verticales para web (md y superior) */}
        <Hidden smDown>
          <Grid item md={2}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={selectedTab}
              onChange={this.handleTabChange}
              className={classNames(classes.verticalTabs, this.props.classes.tabTextWhite)}
              classes={{
                indicator: classes.tabIndicator,
                flexContainer: classes.verticalTabsFlexContainer
              }}
            >
              {tabSections.map((item, index) => (
                <Tab
                  key={index}
                  label={item.sec_name ? item.sec_name.toString().trim() : ''}
                  className={classes.verticalTab}
                />
              ))}
            </Tabs>
          </Grid>
        </Hidden>

        {/* Tabs horizontales para tablet y móvil (sm y menor) */}
        <Hidden mdUp>
          <Grid item xs={12}>
            <Tabs
              variant="scrollable"
              scrollable
              scrollButtons="on"
              value={selectedTab}
              onChange={this.handleTabChange}
              className={classNames(classes.horizontalTabs, this.props.classes.tabTextWhite)}
              classes={{
                indicator: classes.tabIndicator,
                scrollButtons: 'btnScroll'
              }}
            >
              {tabSections.map((item, index) => (
                <Tab
                  key={index}
                  label={item.sec_name ? item.sec_name.toString().trim() : ''}
                  className={classes.horizontalTab}
                />
              ))}
            </Tabs>
          </Grid>
        </Hidden>

        <Grid item xs={12} md={10}>
          {tabSections.map((item, index) => {
            
            const isRelevantSection = item.sec_tipo === "Relevante"
            const isColumnsSection = item.sec_tipo === "NotasColumnas"
            return (
            <div
              key={index}
              role="tabpanel"
              hidden={selectedTab !== index}
              style={{ display: selectedTab === index ? 'block' : 'none' }}
            >
              {selectedTab === index && (
                <div>
                  <PapperBlock
                    secName={item.sec_name ? item.sec_name.toString().trim() : ''}
                    img={item.sec_icono}
                    isVisible={item.sec_totalContent > 0}
                    title={item.sec_name}
                    colorTitle={'#000000'}
                    colorMode
                  >
                    {/* RELEVANTE ORIGINAL <SliderTap section={item} idMenuSelected={idMenuSelected} isVisible={item.sec_totalContent > 0} /> */}
                    {isColumnsSection ? (
                      <SliderEditoriales section={item} idMenuSelected={idMenuSelected} autor onlyCarousel isSearching={isSearching} /> ) : (
                      <SliderCard section={item} idMenuSelected={idMenuSelected} noImage={isRelevantSection} noKicker={isRelevantSection} isWhiteBackground={false} isSearching={isSearching}/>
                    )}
                  </PapperBlock>
                </div>
              )}
            </div>
          )})}
        </Grid>
      </Grid>
      </div>
      </div>
    );
  }
}


export default withStyles(styles)(NotesTabs);
